export const LOCATION_TYPE_VALUES = {
  ITEM       : 'Lokasi Item',
  BOX        : 'Lokasi Box',
  INCLUSION  : 'Lokasi Kelengkapan'
}

export const LOCATION_TYPE_LABELS = {
  [LOCATION_TYPE_VALUES.ITEM]      : 'Item Location',
  [LOCATION_TYPE_VALUES.BOX]       : 'Box Location',
  [LOCATION_TYPE_VALUES.INCLUSION] : 'Inclusion Location'
}

export const LOCATION_TYPE_OPTIONS = [
  { key: '', label: 'All' },
  { key: LOCATION_TYPE_VALUES.ITEM, label: LOCATION_TYPE_LABELS[LOCATION_TYPE_VALUES.ITEM] },
  { key: LOCATION_TYPE_VALUES.BOX, label: LOCATION_TYPE_LABELS[LOCATION_TYPE_VALUES.BOX] },
  { key: LOCATION_TYPE_VALUES.INCLUSION, label: LOCATION_TYPE_LABELS[LOCATION_TYPE_VALUES.INCLUSION] }
]

export const LOCATION_TYPE_FORM_OPTIONS = LOCATION_TYPE_OPTIONS.filter((option) => option.key)

export const getLocationTypeLabel = (typeName) => LOCATION_TYPE_LABELS[typeName] || typeName || '-'